import { Button, Space } from "antd";

interface OutgoingFBCallControlsProps {
  callState: "outgoing_init" | "connecting" | "connected" | "ended";
  isMuted: boolean;
  isSpeakerOn: boolean;
  isProcessing: boolean;
  onInitiate?: () => void;
  onCancel: () => void;
  onTerminate: () => void;
  onToggleMute: () => void;
  onToggleSpeaker: () => void;
}

export const OutgoingFBCallControls = ({
  callState,
  isMuted,
  isSpeakerOn,
  isProcessing,
  onInitiate,
  onCancel,
  onTerminate,
  onToggleMute,
  onToggleSpeaker,
}: OutgoingFBCallControlsProps) => {
  const renderOutgoingInitControls = () => <Space>Initiating call...</Space>;

  const renderConnectingControls = () => (
    <Space>
      <Button
        size="small"
        icon={<i className="ri-loader-4-line animate-spin"></i>}
        disabled
      >
        Connecting...
      </Button>
      <Button
        danger
        size="small"
        icon={<i className="ri-phone-off-line"></i>}
        onClick={onCancel}
        loading={isProcessing}
      >
        Cancel
      </Button>
    </Space>
  );

  const renderConnectedControls = () => (
    <Space>
      <Button
        type={isMuted ? "default" : "primary"}
        size="small"
        icon={<i className={isMuted ? "ri-mic-off-line" : "ri-mic-line"}></i>}
        onClick={onToggleMute}
        disabled={isProcessing}
      >
        {isMuted ? "Unmute" : "Mute"}
      </Button>

      <Button
        type={isSpeakerOn ? "primary" : "default"}
        size="small"
        icon={<i className="ri-volume-up-line"></i>}
        onClick={onToggleSpeaker}
        disabled={isProcessing}
      >
        Speaker
      </Button>

      <Button
        danger
        size="small"
        icon={<i className="ri-phone-off-line"></i>}
        onClick={onTerminate}
        loading={isProcessing}
      >
        End Call
      </Button>
    </Space>
  );

  const renderEndedControls = () => (
    <div className="text-center text-gray-500 text-sm">Call ended</div>
  );

  switch (callState) {
    case "outgoing_init":
      return renderOutgoingInitControls();
    case "connecting":
      return renderConnectingControls();
    case "connected":
      return renderConnectedControls();
    case "ended":
      return renderEndedControls();
    default:
      return null;
  }
};
